import Units from "../../../utils/Units";
import StaticAxis from "../axes/StaticAxis";
import Day from "../axes/Day";
import Config from "../../../Config";
import Time from "../axes/Time";

let LocationNotification = {
    type: "line",
    label: "Location Notification",
    fill: false,
    lineTension: 0,
    colorPalette: 16,
    borderWidth:0,
    showLine:false,
    spanGaps: false,

    pointStyle: "circle",
    pointRadius:3,
    pointHoverRadius:6,
    pointBorderWidth:0,
    pointBackgroundColor: Config.colorPalette[16]['stroke'],

    /** show allways at 80% position*/
    dataTransformCallback: function(time, channelValue, dataSets) {
        if (null !== channelValue) {
            return 10;
        }

        return null;
    },

    /**show real string value*/
    tooltipLabelValueCallback: (value, point) => {
        return point['v'];
    },

    yAxis:StaticAxis,
    xAxis:Time
};

export default LocationNotification;



// WEBPACK FOOTER //
// ./src/components/chart/channels/LocationNotification.js